<div class="flex flex-col w-full gap-1">
    <label [attr.for]="id" class="font-bold text-black">{{ label }}</label>

    <div class="w-full flex h-8 gap-1">
        <input
            [ngClass]="{ invalid: tentativa }"
            [type]="type"
            [id]="id"
            [placeholder]="placeholder"
            [readOnly]="!!isReadOnly"
            [(ngModel)]="value"
            (blur)="onBlur.emit($event)"
            (keypress)="onKeypress.emit($event)"
            autocomplete="off"
            pInputText
            class="bg-white flex-1 min-w-0 border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-emerald-300 rounded-lg"
        />

        <div
            class="w-12 shrink-0 h-full"
        >
            <ng-content></ng-content>
        </div>
    </div>
</div>
